import api from '@/services/api'

export const createEnpsResearch = async form => {
    try {
        const response = await api.post('enps-researches', form)
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const updateEnpsResearch = async (id, form) => {
    try {
        const response = await api.put('enps-researches/' + id, form)
        return response.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getEnpsByTeams = async (params = {}) => {
    try {
        const resp = await api.get(`enps-teams`, {
            params,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getEnpsResearches = async (params = {}) => {
    try {
        const resp = await api.get('enps-researches', {
            params,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const deleteEnpsResearch = async id => {
    try {
        return await api.delete('enps-researches/' + id)
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const applyResearch = async id => {
    try {
        return await api.put(`enps-researches/${id}/apply`)
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const closeResearch = async id => {
    try {
        return await api.put(`enps-researches/${id}/close`)
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getEnpsReport = async (params = {}) => {
    try {
        const resp = await api.get(`enps-report`, {
            params,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getEnpsComments = async params => {
    try {
        const resp = await api.get(`enps-comments`, {
            params,
        })
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getEnpsAvegare = async () => {
    try {
        const resp = await api.get(`companies-enps-average`)
        return resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}

export const getResearch = async id => {
    try {
        const response = await api.get('enps-researches/' + id, {
            params: {
                with: 'teams',
            },
        })
        return response.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}
